<template>
  <div class="diseaseList">
    <div class="diseaseList_centre">
      <!--选择-->
      <div class="diseaseList_select">
        <div class="diseaseList_selectCentre">
          <!--一级科室-->
          <div class="oneDepartment">
            <div class="title" @click="handleToShow()">一级科室</div>
            <div class="oneDepartment_list">
              <div class="item_list">内科</div>
              <div class="item_list">外科</div>
              <div class="item_list">妇产科</div>
              <div class="item_list">儿科</div>
              <div class="item_list">男性科</div>
              <div class="item_list">无官科</div>
              <div class="item_list">皮肤性病科</div>
              <div class="item_list">肿瘤科</div>
              <div class="item_list">不孕不育科</div>
              <div class="item_list">其他</div>
            </div>
          </div>
          <!--二级科室-->
          <div class="twoDepartment">
            <div class="title">二级科室</div>
            <div class="twoDepartment_list">
              <div class="item_list">内科</div>
              <div class="item_list">外科</div>
              <div class="item_list">妇产科</div>
              <div class="item_list">儿科</div>
              <div class="item_list">男性科</div>
              <div class="item_list">无官科</div>
              <div class="item_list">皮肤性病科</div>
              <div class="item_list">肿瘤科</div>
              <div class="item_list">不孕不育科</div>
              <div class="item_list">其他</div>
            </div>
          </div>
        </div>
        <!--结果列表-->
        <div class="diseaseList_result">
          <div class="result_list">
            <div class="item_list">
              <div class="title">A</div>
              <div class="result_item">
                <div class="item_list" @click="handleToShow()">内科</div>
                <div class="item_list">外科</div>
                <div class="item_list">妇产科</div>
                <div class="item_list">儿科</div>
                <div class="item_list">男性科</div>
                <div class="item_list">无官科</div>
                <div class="item_list">皮肤性病科</div>
                <div class="item_list">肿瘤科</div>
                <div class="item_list">不孕不育科</div>
                <div class="item_list">其他</div>
                <div class="item_list">外科</div>
                <div class="item_list">妇产科</div>
              </div>
            </div>
            <div class="item_list">
              <div class="title">B</div>
              <div class="result_item">
                <div class="item_list">内科</div>
                <div class="item_list">外科</div>
                <div class="item_list">妇产科</div>
                <div class="item_list">儿科</div>
                <div class="item_list">男性科</div>
                <div class="item_list">无官科</div>
                <div class="item_list">皮肤性病科</div>
                <div class="item_list">肿瘤科</div>
                <div class="item_list">不孕不育科</div>
                <div class="item_list">其他</div>
                <div class="item_list">外科</div>
                <div class="item_list">妇产科</div>
              </div>
            </div>
            <div class="item_list">
              <div class="title">C</div>
              <div class="result_item">
                <div class="item_list">内科</div>
                <div class="item_list">外科</div>
                <div class="item_list">妇产科</div>
                <div class="item_list">儿科</div>
                <div class="item_list">男性科</div>
                <div class="item_list">无官科</div>
                <div class="item_list">其他</div>
              </div>
            </div>
            <div class="item_list">
              <div class="title">D</div>
              <div class="result_item">
                <div class="item_list">内科</div>
                <div class="item_list">外科</div>
                <div class="item_list">妇产科</div>
                <div class="item_list">儿科</div>
                <div class="item_list">男性科</div>
                <div class="item_list">无官科</div>
                <div class="item_list">皮肤性病科</div>
                <div class="item_list">肿瘤科</div>
                <div class="item_list">其他</div>
              </div>
            </div>
            <div class="item_list">
              <div class="title">E</div>
              <div class="result_item">
                <div class="item_list">内科</div>
                <div class="item_list">外科</div>
                <div class="item_list">妇产科</div>
                <div class="item_list">儿科</div>
                <div class="item_list">男性科</div>
                <div class="item_list">无官科</div>
                <div class="item_list">无官科</div>
                <div class="item_list">皮肤性病科</div>
                <div class="item_list">肿瘤科</div>
                <div class="item_list">不孕不育科</div>
                <div class="item_list">其他</div>
              </div>
            </div>
            <div class="item_list">
              <div class="title">F</div>
              <div class="result_item">
                <div class="item_list">内科</div>
                <div class="item_list">外科</div>
                <div class="item_list">妇产科</div>
                <div class="item_list">儿科</div>
                <div class="item_list">男性科</div>
                <div class="item_list">肿瘤科</div>
                <div class="item_list">不孕不育科</div>
                <div class="item_list">其他</div>
              </div>
            </div>
            <div class="item_list">
              <div class="title">G</div>
              <div class="result_item">
                <div class="item_list">内科</div>
                <div class="item_list">无官科</div>
                <div class="item_list">皮肤性病科</div>
                <div class="item_list">肿瘤科</div>
                <div class="item_list">不孕不育科</div>
                <div class="item_list">其他</div>
              </div>
            </div>
            <div class="item_list">
              <div class="title">F</div>
              <div class="result_item">
                <div class="item_list">内科</div>
                <div class="item_list">外科</div>
                <div class="item_list">妇产科</div>
                <div class="item_list">儿科</div>
                <div class="item_list">妇产科</div>
                <div class="item_list">儿科</div>
                <div class="item_list">男性科</div>
                <div class="item_list">无官科</div>
                <div class="item_list">皮肤性病科</div>
                <div class="item_list">肿瘤科</div>
                <div class="item_list">不孕不育科</div>
                <div class="item_list">其他</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--内容-->
      <div class="home_disease">
        <!--card-->
        <div class="disease_card">
          <div class="disease_card_top">最近更新</div>
          <div class="disease_card_warp">
            <!--左-->
            <div class="disease_cardLeft">
              <div class="cardLeft_box">
                <div class="disease_card_left">
                  <!--图片区-->
                  <div class="card_left_img">
                    <div class="img_list">
                      <img src="../../../assets/images/home/jibing1.jpeg" alt="">
                      <div>孩子不吃饭怎么办</div>
                    </div>
                    <div class="img_list">
                      <img src="../../../assets/images/home/jibing2.jpeg" alt="">
                      <div>打一顿就好了</div>
                    </div>
                    <div class="img_list">
                      <img src="../../../assets/images/home/jibing3.jpeg" alt="">
                      <div>如果不行</div>
                    </div>
                    <div class="img_list">
                      <img src="../../../assets/images/home/jibing4.jpeg" alt="">
                      <div>那就打两顿</div>
                    </div>
                  </div>
                </div>
                <div class="disease_card_center">
                  <!--热门问答-->
                  <div class="card_center_question">
                    <div class="item_question">
                      <div>肝炎的早期症状有哪些呢？</div>
                      <span>肝炎流行季节或流行地区以及家中有急性肝炎患者时应高度警惕、时时提防。少数人在发病前曾有过类似“感冒”的症状少数人在发病前曾有过类似少数人在发病前曾有过类似少数人在发病前曾有过类似少数人在发病前曾有过类似少数人在发病前曾有过类似少数人在发病前曾有过类似少数人在发病前曾有过类似少数人在发病前曾有过类似</span>
                    </div>
                  </div>
                  <!--问题列表-->
                  <div class="card_hot_topic">
                    <div class="hot_topic_list">
                      <div class="item_topic_list">
                        <div class="hot_topic_text">
                          <div class="mask_box"></div>
                          <div class="Topic_text">没有钱的症状是什么？</div>
                        </div>
                        <div class="hot_topic_time">2020-03-16</div>
                      </div>
                    </div>
                    <div class="hot_topic_list">
                      <div class="item_topic_list">
                        <div class="hot_topic_text">
                          <div class="mask_box"></div>
                          <div class="Topic_text">没有钱的症状是什么？</div>
                        </div>
                        <div class="hot_topic_time">2020-03-16</div>
                      </div>
                    </div>
                    <div class="hot_topic_list">
                      <div class="item_topic_list">
                        <div class="hot_topic_text">
                          <div class="mask_box"></div>
                          <div class="Topic_text">没有钱的症状是什么？</div>
                        </div>
                        <div class="hot_topic_time">2020-03-16</div>
                      </div>
                    </div>
                    <div class="hot_topic_list">
                      <div class="item_topic_list">
                        <div class="hot_topic_text">
                          <div class="mask_box"></div>
                          <div class="Topic_text">没有钱的症状是什么？</div>
                        </div>
                        <div class="hot_topic_time">2020-03-16</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="cardLeft_bottom">
                <!--列表区-->
                <div class="card_left_text">
                  <div class="text_list">
                    <div class="item_list">
                      <div class="title">
                        <img v-if="1" width="20px" height="20px" src="../../../assets/images/home/shengyin.png" alt="">
                        <img v-if="0" width="28px" height="20px" src="../../../assets/images/home/u1791.png" alt="">
                        <span>孩子为什么不吃饭孩子为什么不吃饭孩子为什么不吃饭孩子为什么不吃饭孩子为什么不吃饭孩子为什么不吃饭？</span>
                      </div>
                      <div class="time">2013-03-13</div>
                    </div>
                  </div>
                  <div class="text_list">
                    <div class="item_list">
                      <div class="title">
                        <img v-if="1" width="20px" height="20px" src="../../../assets/images/home/shengyin.png" alt="">
                        <img v-if="0" width="28px" height="20px" src="../../../assets/images/home/u1791.png" alt="">
                        <span>孩子为什么不吃饭孩子为什么不吃饭孩子为什么不吃饭孩子为什么不吃饭孩子为什么不吃饭孩子为什么不吃饭？</span>
                      </div>
                      <div class="time">2013-03-13</div>
                    </div>
                  </div>
                  <div class="text_list">
                    <div class="item_list">
                      <div class="title">
                        <img v-if="1" width="20px" height="20px" src="../../../assets/images/home/shengyin.png" alt="">
                        <img v-if="0" width="28px" height="20px" src="../../../assets/images/home/u1791.png" alt="">
                        <span>孩子为什么不吃饭孩子为什么不吃饭孩子为什么不吃饭孩子为什么不吃饭孩子为什么不吃饭孩子为什么不吃饭？</span>
                      </div>
                      <div class="time">2013-03-13</div>
                    </div>
                  </div>
                  <div class="text_list">
                    <div class="item_list">
                      <div class="title">
                        <img v-if="1" width="20px" height="20px" src="../../../assets/images/home/shengyin.png" alt="">
                        <img v-if="0" width="28px" height="20px" src="../../../assets/images/home/u1791.png" alt="">
                        <span>孩子为什么不吃饭孩子为什么不吃饭孩子为什么不吃饭孩子为什么不吃饭孩子为什么不吃饭孩子为什么不吃饭？</span>
                      </div>
                      <div class="time">2013-03-13</div>
                    </div>
                  </div>
                  <div class="text_list">
                    <div class="item_list">
                      <div class="title">
                        <img v-if="1" width="20px" height="20px" src="../../../assets/images/home/shengyin.png" alt="">
                        <img v-if="0" width="28px" height="20px" src="../../../assets/images/home/u1791.png" alt="">
                        <span>孩子为什么不吃饭孩子为什么不吃饭孩子为什么不吃饭孩子为什么不吃饭孩子为什么不吃饭孩子为什么不吃饭？</span>
                      </div>
                      <div class="time">2013-03-13</div>
                    </div>
                  </div>
                  <div class="text_list">
                    <div class="item_list">
                      <div class="title">
                        <img v-if="1" width="20px" height="20px" src="../../../assets/images/home/shengyin.png" alt="">
                        <img v-if="0" width="28px" height="20px" src="../../../assets/images/home/u1791.png" alt="">
                        <span>孩子为什么不吃饭孩子为什么不吃饭孩子为什么不吃饭孩子为什么不吃饭孩子为什么不吃饭孩子为什么不吃饭？</span>
                      </div>
                      <div class="time">2013-03-13</div>
                    </div>
                  </div>
                  <div class="text_list">
                    <div class="item_list">
                      <div class="title">
                        <img v-if="1" width="20px" height="20px" src="../../../assets/images/home/shengyin.png" alt="">
                        <img v-if="0" width="28px" height="20px" src="../../../assets/images/home/u1791.png" alt="">
                        <span>孩子为什么不吃饭孩子为什么不吃饭孩子为什么不吃饭孩子为什么不吃饭孩子为什么不吃饭孩子为什么不吃饭？</span>
                      </div>
                      <div class="time">2013-03-13</div>
                    </div>
                  </div>
                  <div class="text_list">
                    <div class="item_list">
                      <div class="title">
                        <img v-if="1" width="20px" height="20px" src="../../../assets/images/home/shengyin.png" alt="">
                        <img v-if="0" width="28px" height="20px" src="../../../assets/images/home/u1791.png" alt="">
                        <span>孩子为什么不吃饭孩子为什么不吃饭孩子为什么不吃饭孩子为什么不吃饭孩子为什么不吃饭孩子为什么不吃饭？</span>
                      </div>
                      <div class="time">2013-03-13</div>
                    </div>
                  </div>
                  <div class="text_list">
                    <div class="item_list">
                      <div class="title">
                        <img v-if="1" width="20px" height="20px" src="../../../assets/images/home/shengyin.png" alt="">
                        <img v-if="0" width="28px" height="20px" src="../../../assets/images/home/u1791.png" alt="">
                        <span>孩子为什么不吃饭孩子为什么不吃饭孩子为什么不吃饭孩子为什么不吃饭孩子为什么不吃饭孩子为什么不吃饭？</span>
                      </div>
                      <div class="time">2013-03-13</div>
                    </div>
                  </div>
                  <div class="text_list">
                    <div class="item_list">
                      <div class="title">
                        <img v-if="1" width="20px" height="20px" src="../../../assets/images/home/shengyin.png" alt="">
                        <img v-if="0" width="28px" height="20px" src="../../../assets/images/home/u1791.png" alt="">
                        <span>孩子为什么不吃饭孩子为什么不吃饭孩子为什么不吃饭孩子为什么不吃饭孩子为什么不吃饭孩子为什么不吃饭？</span>
                      </div>
                      <div class="time">2013-03-13</div>
                    </div>
                  </div>
                  <div class="text_list">
                    <div class="item_list">
                      <div class="title">
                        <img v-if="1" width="20px" height="20px" src="../../../assets/images/home/shengyin.png" alt="">
                        <img v-if="0" width="28px" height="20px" src="../../../assets/images/home/u1791.png" alt="">
                        <span>孩子为什么不吃饭孩子为什么不吃饭孩子为什么不吃饭孩子为什么不吃饭孩子为什么不吃饭孩子为什么不吃饭？</span>
                      </div>
                      <div class="time">2013-03-13</div>
                    </div>
                  </div>
                  <div class="text_list">
                    <div class="item_list">
                      <div class="title">
                        <img v-if="1" width="20px" height="20px" src="../../../assets/images/home/shengyin.png" alt="">
                        <img v-if="0" width="28px" height="20px" src="../../../assets/images/home/u1791.png" alt="">
                        <span>孩子为什么不吃饭孩子为什么不吃饭孩子为什么不吃饭孩子为什么不吃饭孩子为什么不吃饭孩子为什么不吃饭？</span>
                      </div>
                      <div class="time">2013-03-13</div>
                    </div>
                  </div>
                  <div class="text_list">
                    <div class="item_list">
                      <div class="title">
                        <img v-if="1" width="20px" height="20px" src="../../../assets/images/home/shengyin.png" alt="">
                        <img v-if="0" width="28px" height="20px" src="../../../assets/images/home/u1791.png" alt="">
                        <span>孩子为什么不吃饭孩子为什么不吃饭孩子为什么不吃饭孩子为什么不吃饭孩子为什么不吃饭孩子为什么不吃饭？</span>
                      </div>
                      <div class="time">2013-03-13</div>
                    </div>
                  </div>
                  <div class="text_list">
                    <div class="item_list">
                      <div class="title">
                        <img v-if="1" width="20px" height="20px" src="../../../assets/images/home/shengyin.png" alt="">
                        <img v-if="0" width="28px" height="20px" src="../../../assets/images/home/u1791.png" alt="">
                        <span>孩子为什么不吃饭孩子为什么不吃饭孩子为什么不吃饭孩子为什么不吃饭孩子为什么不吃饭孩子为什么不吃饭？</span>
                      </div>
                      <div class="time">2013-03-13</div>
                    </div>
                  </div>
                  <div class="text_list">
                    <div class="item_list">
                      <div class="title">
                        <img v-if="1" width="20px" height="20px" src="../../../assets/images/home/shengyin.png" alt="">
                        <img v-if="0" width="28px" height="20px" src="../../../assets/images/home/u1791.png" alt="">
                        <span>孩子为什么不吃饭孩子为什么不吃饭孩子为什么不吃饭孩子为什么不吃饭孩子为什么不吃饭孩子为什么不吃饭？</span>
                      </div>
                      <div class="time">2013-03-13</div>
                    </div>
                  </div>
                  <div class="text_list">
                    <div class="item_list">
                      <div class="title">
                        <img v-if="1" width="20px" height="20px" src="../../../assets/images/home/shengyin.png" alt="">
                        <img v-if="0" width="28px" height="20px" src="../../../assets/images/home/u1791.png" alt="">
                        <span>孩子为什么不吃饭孩子为什么不吃饭孩子为什么不吃饭孩子为什么不吃饭孩子为什么不吃饭孩子为什么不吃饭？</span>
                      </div>
                      <div class="time">2013-03-13</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!--右-->
            <div class="disease_card_right">
              <div class="card_rightTitle">大家都在看</div>
              <div class="GraphicText">
                <div class="GraphicText_list">
                  <div class="item_GraphicText_list">
                    <div class="GraphicImg">
                      <img src="../../../assets/images/home/jibing3.jpeg" alt="">
                    </div>
                    <div class="textTime">
                      <div>没有心脏病的人也会出现心源性猝死吗，这是为什么呢？没有心脏病的人也会出现心源性猝死吗没有心脏病的人也会出现心源性猝死吗没有心脏病的人也会出现心源性猝死吗没有心脏病的人也会出现心源性猝死吗没有心脏病的人也会出现心源性猝死吗</div>
                      <span>2020-03-12</span>
                    </div>
                  </div>
                </div>
                <div class="GraphicText_list">
                  <div class="item_GraphicText_list">
                    <div class="GraphicImg">
                      <img src="../../../assets/images/home/jibing3.jpeg" alt="">
                    </div>
                    <div class="textTime">
                      <div>没有心脏病的人也会出现心源性猝死吗，这是为什么呢？没有心脏病的人也会出现心源性猝死吗没有心脏病的人也会出现心源性猝死吗没有心脏病的人也会出现心源性猝死吗没有心脏病的人也会出现心源性猝死吗没有心脏病的人也会出现心源性猝死吗</div>
                      <span>2020-03-12</span>
                    </div>
                  </div>
                </div>
                <div class="GraphicText_list">
                  <div class="item_GraphicText_list">
                    <div class="GraphicImg">
                      <img src="../../../assets/images/home/jibing3.jpeg" alt="">
                    </div>
                    <div class="textTime">
                      <div>没有心脏病的人也会出现心源性猝死吗，这是为什么呢？没有心脏病的人也会出现心源性猝死吗没有心脏病的人也会出现心源性猝死吗没有心脏病的人也会出现心源性猝死吗没有心脏病的人也会出现心源性猝死吗没有心脏病的人也会出现心源性猝死吗</div>
                      <span>2020-03-12</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="hot_GraphicText">
                <div class="hot_list">
                  <div class="item_hot_list">
                    <div class="joint_box">
                      <img v-if="1" width="40px" height="20px" src="../../../assets/images/home/left_img.png" alt="">
                      <img v-if="0" width="28px" height="20px" src="../../../assets/images/home/u1791.png" alt="">
                      <img v-if="0" width="20px" height="20px" src="../../../assets/images/home/shengyin.png" alt="">
                    </div>
                    <div class="hot_text">冠心病的早期症状有哪些？怎么预防</div>
                  </div>
                </div>
                <div class="hot_list">
                  <div class="item_hot_list">
                    <div class="joint_box">
                      <img v-if="0" width="40px" height="20px" src="../../../assets/images/home/left_img.png" alt="">
                      <img width="28px" height="20px" src="../../../assets/images/home/u1791.png" alt="">
                      <img v-if="0" width="20px" height="20px" src="../../../assets/images/home/shengyin.png" alt="">
                    </div>
                    <div class="hot_text">冠心病的早期症状有哪些？怎么预防</div>
                  </div>
                </div>
                <div class="hot_list">
                  <div class="item_hot_list">
                    <div class="joint_box">
                      <img v-if="0" width="40px" height="20px" src="../../../assets/images/home/left_img.png" alt="">
                      <img v-if="0" width="28px" height="20px" src="../../../assets/images/home/u1791.png" alt="">
                      <img v-if="1" width="20px" height="20px" src="../../../assets/images/home/shengyin.png" alt="">
                    </div>
                    <div class="hot_text">冠心病的早期症状有哪些？怎么预防</div>
                  </div>
                </div>
                <div class="hot_list">
                  <div class="item_hot_list">
                    <div class="joint_box">
                      <img v-if="0" width="40px" height="20px" src="../../../assets/images/home/left_img.png" alt="">
                      <img v-if="0" width="28px" height="20px" src="../../../assets/images/home/u1791.png" alt="">
                      <img v-if="1" width="20px" height="20px" src="../../../assets/images/home/shengyin.png" alt="">
                    </div>
                    <div class="hot_text">冠心病的早期症状有哪些？怎么预防</div>
                  </div>
                </div>
                <div class="hot_list">
                  <div class="item_hot_list">
                    <div class="joint_box">
                      <img v-if="0" width="40px" height="20px" src="../../../assets/images/home/left_img.png" alt="">
                      <img v-if="0" width="28px" height="20px" src="../../../assets/images/home/u1791.png" alt="">
                      <img v-if="1" width="20px" height="20px" src="../../../assets/images/home/shengyin.png" alt="">
                    </div>
                    <div class="hot_text">冠心病的早期症状有哪些？怎么预防</div>
                  </div>
                </div>
                <div class="hot_list">
                  <div class="item_hot_list">
                    <div class="joint_box">
                      <img v-if="0" width="40px" height="20px" src="../../../assets/images/home/left_img.png" alt="">
                      <img v-if="0" width="28px" height="20px" src="../../../assets/images/home/u1791.png" alt="">
                      <img v-if="1" width="20px" height="20px" src="../../../assets/images/home/shengyin.png" alt="">
                    </div>
                    <div class="hot_text">冠心病的早期症状有哪些？怎么预防</div>
                  </div>
                </div>
                <div class="hot_list">
                  <div class="item_hot_list">
                    <div class="joint_box">
                      <img v-if="0" width="40px" height="20px" src="../../../assets/images/home/left_img.png" alt="">
                      <img v-if="0" width="28px" height="20px" src="../../../assets/images/home/u1791.png" alt="">
                      <img v-if="1" width="20px" height="20px" src="../../../assets/images/home/shengyin.png" alt="">
                    </div>
                    <div class="hot_text">冠心病的早期症状有哪些？怎么预防</div>
                  </div>
                </div>
                <div class="hot_list">
                  <div class="item_hot_list">
                    <div class="joint_box">
                      <img v-if="0" width="40px" height="20px" src="../../../assets/images/home/left_img.png" alt="">
                      <img v-if="0" width="28px" height="20px" src="../../../assets/images/home/u1791.png" alt="">
                      <img v-if="1" width="20px" height="20px" src="../../../assets/images/home/shengyin.png" alt="">
                    </div>
                    <div class="hot_text">冠心病的早期症状有哪些？怎么预防</div>
                  </div>
                </div>
                <div class="hot_list">
                  <div class="item_hot_list">
                    <div class="joint_box">
                      <img v-if="0" width="40px" height="20px" src="../../../assets/images/home/left_img.png" alt="">
                      <img v-if="0" width="28px" height="20px" src="../../../assets/images/home/u1791.png" alt="">
                      <img v-if="1" width="20px" height="20px" src="../../../assets/images/home/shengyin.png" alt="">
                    </div>
                    <div class="hot_text">冠心病的早期症状有哪些？怎么预防</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "List",
    data(){
      return {

      }
    },
    methods:{
      handleToShow(){
        this.$router.push({path:'/tt/diseaseShow'+'.html',query:{id:0}})
      },
    },
    mounted() {

    },
  }
</script>
<style lang="stylus" scoped>
  .diseaseList{
    .diseaseList_centre{
      width: 1200px
      margin 0 auto
      .diseaseList_select{
        margin-top 20px
        .diseaseList_selectCentre{
          border 1px solid #eee
          border-radius: 9px;
          padding 20px 20px 10px 20px
          .oneDepartment{
            display flex
            flex-wrap wrap
            align-items center
            min-height 60px
            &:after{
              content ''
              display block
              height: 1px
              width 100%
              border-top 1px dashed #eee
              margin 10px  10px 0 10px
            }
            .title{
              font-weight: 700;
              font-style: normal;
              font-size: 16px;
              color: #333
              margin-right 20px
            }
            .oneDepartment_list{
              flex 1
              display flex
              flex-wrap wrap
              .item_list{
                font-size: 14px;
                color: #333
                margin-right 20px
                padding 10px 0
                cursor: pointer
              }
            }
          }
          .twoDepartment{
            display flex
            flex-wrap wrap
            align-items center
            min-height 60px
            .title{
              font-weight: 700;
              font-style: normal;
              font-size: 16px;
              color: #333
              margin-right 20px
            }
            .twoDepartment_list{
              flex 1
              display flex
              flex-wrap wrap
              .item_list{
                font-size: 14px;
                color: #333
                margin-right 20px
                padding 10px 0
                cursor: pointer
              }
            }
          }
        }
        .diseaseList_result{
          padding 0 20px
          .result_list{
            .item_list{
              display flex
              flex-wrap wrap
              align-items center
              min-height 30px
              margin-bottom 6px
              .title{
                width: 25px;
                height: 25px;
                background #169bd5
                text-align: center
                line-height 25px
                font-weight: 700;
                font-size: 20px;
                color: #fff
                margin-right 10px
              }
              .result_item{
                flex 1
                display flex
                flex-wrap wrap
                align-items center
                .item_list{
                  font-size: 14px;
                  color: #333
                  margin-right 20px
                  cursor: pointer
                  margin-bottom 0
                }
              }
            }
          }
        }
      }
      // 内容
      .home_disease{
        .disease_card{
          margin-top 30px
          .disease_card_top{
            margin-bottom 20px
            font-weight: 700;
            font-style: normal;
            font-size: 16px;
            color: #333
            display flex
            align-items center
            &:after{
              content ''
              display block
              flex 1
              height: 1px
              border-top 1px dashed #eee
              margin-left 10px
            }
          }
          .disease_card_warp{
            display flex
            justify-content space-between
            position relative
            .disease_cardLeft{
              .cardLeft_box{
                display flex
                justify-content space-between
                width: 820px
                .disease_card_left{
                  padding-right 2px
                  width:400px
                  //height 400px
                  .card_left_img{
                    display flex
                    justify-content space-between
                    flex-wrap wrap
                    .img_list{
                      position relative
                      margin-bottom 12px
                      cursor: pointer
                      >img{
                        width: 195px
                        height: 135px
                      }
                      >div{
                        position absolute
                        left:0
                        bottom:3px
                        width: 195px
                        height: 30px
                        background rgba(0,0,0,0.5)
                        color: #fff
                        font-weight 700
                        line-height 30px
                        /*省略号*/
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        text-align: center
                      }
                    }
                  }
                  .card_left_text{
                    .text_list{
                      cursor: pointer
                      height 50px
                      background #f2f2f2
                      margin-bottom 14px
                      padding 0 10px
                      &:last-child{
                        margin-bottom 0
                      }
                      .item_list{
                        height 50px
                        display flex
                        align-items center
                        justify-content space-between
                        >span{
                          width 70%
                          color: #5E5E5E
                          font-size:14px
                          font-weight 700
                          overflow: hidden;
                          text-overflow: ellipsis;
                          white-space: nowrap;
                        }
                        >div{
                          color: #868686
                          font-size 12px
                        }
                      }
                    }
                  }
                }
                .disease_card_center{
                  width:400px
                  padding 0 2px
                  .card_center_question{
                    .item_question{
                      >div{
                        font-weight: 700;
                        font-size: 16px;
                        margin-bottom 12px
                        color: #333
                        cursor: pointer
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                      }
                      >span{
                        font-size: 14px;
                        line-height: 22px;
                        color: #333
                        text-overflow: -o-ellipsis-lastline;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 3;
                        -webkit-box-orient: vertical;
                      }
                    }
                  }
                  .card_hot_topic{
                    margin-top 20px
                    .hot_topic_list{
                      padding 14px 10px
                      border-top 1px dashed #eee
                      cursor: pointer
                      .item_topic_list{
                        width 100%
                        display flex
                        justify-content space-between
                        align-items center
                        .hot_topic_text{
                          display flex
                          align-items center
                          .mask_box{
                            width: 10px;
                            height: 10px;
                            border-radius 50%
                            background #bcbcbc
                            margin-right 8px
                          }
                          .Topic_text{
                            color: #5E5E5E
                            font-size 14px
                            font-weight:700
                            width 250px
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                          }
                        }
                        .hot_topic_time{
                          color: #868686
                          font-size 12px
                        }
                      }
                      .hot_topic_text{
                        display flex
                        align-items center
                        .mask_box{
                          width: 10px;
                          height: 10px;
                          border-radius 50%
                          background #bcbcbc
                          margin-right 8px
                        }
                        .Topic_text{
                          color: #5E5E5E
                          font-size 14px
                          font-weight:700
                          width 250px
                          overflow: hidden;
                          text-overflow: ellipsis;
                          white-space: nowrap;
                        }
                      }
                      .hot_topic_time{
                        color: #868686
                        font-size 12px
                      }
                    }
                  }
                  .card_center_text{
                    margin-top 14px
                    .text_list{
                      cursor: pointer
                      height 50px
                      background #f2f2f2
                      margin-bottom 14px
                      padding 0 10px
                      &:last-child{
                        margin-bottom 0
                      }
                      .item_list{
                        height 50px
                        display flex
                        align-items center
                        justify-content space-between
                        >span{
                          width 70%
                          color: #5E5E5E
                          font-size:14px
                          font-weight 700
                          overflow: hidden;
                          text-overflow: ellipsis;
                          white-space: nowrap;
                        }
                        >div{
                          color: #868686
                          font-size 12px
                        }
                      }
                    }
                  }
                }
              }

              .cardLeft_bottom{
                width: 820px
                .card_left_text{
                  display flex
                  flex-wrap wrap
                  justify-content space-between
                  .text_list{
                    width: 400px
                    cursor: pointer
                    height 50px
                    background #f2f2f2
                    margin-bottom 14px
                    padding 0 10px
                    box-sizing border-box
                    &:last-child{
                      margin-bottom 0
                    }
                    .item_list{
                      height 50px
                      display flex
                      align-items center
                      justify-content space-between
                      .title{
                        width 80%
                        color: #5E5E5E
                        font-size:14px
                        font-weight 700
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        display flex
                        align-items center
                        >span{
                          display block
                          width 80%
                          color: #5E5E5E
                          font-size:14px
                          font-weight 700
                          overflow: hidden;
                          text-overflow: ellipsis;
                          white-space: nowrap;
                        }
                        >img{
                          margin-right 6px
                        }
                      }
                      .time{
                        color: #868686
                        font-size 12px
                      }
                    }
                  }
                }
              }
            }
            .disease_card_right{
              width:360px
              .card_rightTitle{
                font-weight: 700;
                font-style: normal;
                font-size: 16px;
                color: #333
                margin-bottom 40px
              }
              .GraphicText{
                .GraphicText_list{
                  margin-bottom 16px
                  display flex
                  flex 1
                  .item_GraphicText_list{
                    display flex
                    .GraphicImg{
                      >img{
                        width: 101px
                        height: 70px
                        margin-right 15px
                      }
                    }
                    .textTime{
                      height: 70px
                      display flex
                      flex-direction column
                      justify-content space-around
                      >div{
                        color: #5E5E5E
                        font-size 14px
                        text-overflow: -o-ellipsis-lastline;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                        line-height 18px
                      }
                      >span{
                        color: #868686
                        font-size 12px
                      }
                    }
                  }
                }
              }
              .hot_GraphicText{
                margin-bottom 21px
                .hot_list{
                  margin-bottom 16px
                  .item_hot_list{
                    display flex
                    align-items center
                    .joint_box{
                      >img{
                        vertical-align middle
                      }
                    }
                    .hot_text{
                      font-size: 14px;
                      color: #5E5E5E;
                      margin-left 12px
                      width: 100%
                      overflow: hidden;
                      text-overflow: ellipsis;
                      white-space: nowrap;
                    }
                  }
                }
              }
            }
          }

        }
      }
    }
  }
</style>





// WEBPACK FOOTER //
// src/views/view-tt/diseaseLibrary/List.vue